module.exports = __webpack_public_path__ + "img/facebook.633cb9bd.svg";